import React, { useState } from 'react';

interface RejectRequestModalProps {
  requestId?: string;
}

const RejectRequestModal: React.FC<RejectRequestModalProps> = ({ requestId }) => {
  const [rejectData, setRejectData] = useState({
    reason: '',
    comments: '',
    notifyParent: true,
    allowResubmission: true
  });

  const rejectReasons = [
    'Incomplete documentation',
    'Invalid request type',
    'Missing parent consent',
    'Outstanding fees',
    'Incorrect student information',
    'Request not applicable',
    'Administrative hold',
    'Other'
  ];

  const handleReject = () => {
    // TODO: Reject request API call
    console.log('Rejecting request:', requestId, rejectData);
  };

  return (
    <div className="modal fade" id="rejectRequestModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title text-danger">
              <i className="ti ti-x me-2"></i>Reject Request
            </h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div className="modal-body">
            <div className="alert alert-warning">
              <i className="ti ti-alert-triangle me-2"></i>
              This action will reject the document request. The student/parent will be notified.
            </div>
            
            <form>
              <div className="mb-3">
                <label className="form-label">Rejection Reason <span className="text-danger">*</span></label>
                <select 
                  className="form-select"
                  value={rejectData.reason}
                  onChange={(e) => setRejectData({...rejectData, reason: e.target.value})}
                  required
                >
                  <option value="">Select a reason</option>
                  {rejectReasons.map((reason, index) => (
                    <option key={index} value={reason}>{reason}</option>
                  ))}
                </select>
              </div>
              
              <div className="mb-3">
                <label className="form-label">Additional Comments</label>
                <textarea 
                  className="form-control"
                  rows={4}
                  value={rejectData.comments}
                  onChange={(e) => setRejectData({...rejectData, comments: e.target.value})}
                  placeholder="Provide detailed explanation for rejection..."
                />
                <small className="text-muted">
                  This will be included in the notification to the student/parent
                </small>
              </div>

              <div className="mb-3">
                <div className="form-check">
                  <input 
                    className="form-check-input" 
                    type="checkbox" 
                    id="notifyParent"
                    checked={rejectData.notifyParent}
                    onChange={(e) => setRejectData({...rejectData, notifyParent: e.target.checked})}
                  />
                  <label className="form-check-label" htmlFor="notifyParent">
                    Send email notification to parent/guardian
                  </label>
                </div>
              </div>

              <div className="mb-3">
                <div className="form-check">
                  <input 
                    className="form-check-input" 
                    type="checkbox" 
                    id="allowResubmission"
                    checked={rejectData.allowResubmission}
                    onChange={(e) => setRejectData({...rejectData, allowResubmission: e.target.checked})}
                  />
                  <label className="form-check-label" htmlFor="allowResubmission">
                    Allow resubmission after corrections
                  </label>
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>
            <button 
              type="button" 
              className="btn btn-danger" 
              onClick={handleReject}
              disabled={!rejectData.reason}
            >
              <i className="ti ti-x me-2"></i>Confirm Rejection
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectRequestModal;
